module.exports = __webpack_public_path__ + "static/media/nn_group_web_2.5b4d1a4b.png";